import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { FaInstagram } from 'react-icons/fa'
import './App.css'

// Cada linha define quantas colunas terá (cols: 2 ou cols: 3) e quais imagens exibir
const galleryRows = [
  {
    cols: 2,
    items: [
      {
        title: 'Ambiente confortável',
        description: 'Ambiente confortável, com estrutura completa para atender diferentes formatos de evento.',
        size: 'medium',
        image: 'images/ambiente_confortavel.jpeg',
      },
      {
        title: 'Área gourmet',
        description: 'Área gourmet climatizada e equipada um espaço pensado para reunir, celebrar e permanecer.',
        size: 'small',
        image: 'images/area_gourmet.jpeg',
      },
    ],
  },
  {
    cols: 2,
    items: [
      {
        title: 'Jardim',
        description: 'Amplo jardim integrado à área de convivência. \nIdeal para recepções ao ar livre, cerimônias e momentos de descontração',
        size: 'small',
        image: 'images/jardim.jpeg',
      },
      {
        title: 'Piscina',
        description: 'Primeira piscina praia com revestimento monolítico da região e com aquecedor, para garantir seu conforto. \nAliada às pedras naturais, forma a combinação perfeita entre arquitetura e natureza.',
        size: 'medium',
        image: 'images/piscina.jpeg',
      },
    ],
  },
  {
    cols: 3,
    items: [
      {
        title: 'Suítes',
        description: 'Suítes climatizadas para hospedagem \nMais comodidade para anfitriões e convidados, com estrutura para pernoite de até 6 pessoas.',
        size: 'small',
        image: 'images/suite_01.jpeg',
      },
      {
        title: 'Cozinha de apoio',
        description: 'Cozinha de apoio com acesso independente facilita a operação de buffet e fornecedores sem interferir no evento.',
        size: 'small',
        image: 'images/cozinha.jpeg',
      },
      {
        title: 'Banheiros',
        description: 'Banheiros femininos e masculinos. Conforto e praticidade para atender convidados com qualidade',
        size: 'small',
        image: 'images/banheiro.jpeg',
      },
    ],
  },
]

const highlights = [
  'Ambiente cercado por verde e clima acolhedor',
  'Espaço versátil para aniversários, encontros e finais de semana',
  'Estrutura pronta para receber fotos impactantes do local',
]

const amenities = [
  'Piscina em formato orgânico',
  'Projeto arquitetônico que une funcionalidade, conforto e natureza de forma moderna',
  'Amplitude do espaço e possibilidade de hospedagem',
  'Tudo isso dentro de Bauru - sem precisar pegar estrada',
]

const instagramUrl = 'https://instagram.com/recantoselvatti'
const googleMapsEmbedUrl = 'https://www.google.com/maps?q=Recanto%20Selvatti&output=embed'
const googleMapsDirectionsUrl = 'https://www.google.com/maps/search/?api=1&query=Recanto%20Selvatti'
// const eventTypes = [
//   'Aniversário',
//   'Aniversário debutante',
//   'Confraternização corporativa',
//   'Confraternização social',
//   'Casamento',
//   'Hospedagem',
//   'Outro',
// ]

// function validateEmail(email) {
//   // Regex simples para e-mail
//   return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
// }

// function validatePhone(phone) {
//   // Aceita formatos brasileiros (xx) xxxxx-xxxx ou xxxxxxxxxxx
//   return /^(\(\d{2}\)\s?)?\d{4,5}-?\d{4}$/.test(phone) || /^\d{10,11}$/.test(phone)
// }

// // Função para formatar data para o padrão brasileiro
// function formatDateBR(dateStr) {
//   if (!dateStr) return '-';
//   const [yyyy, mm, dd] = dateStr.split('-');
//   if (!yyyy || !mm || !dd) return dateStr;
//   return `${dd}/${mm}/${yyyy}`;
// }

// // Função para aplicar máscara de telefone brasileiro
// function maskPhone(value) {
//   if (!value) return '';
//   // Remove tudo que não for dígito
//   value = value.replace(/\D/g, '');
//   // Aplica máscara para 11 dígitos (celular)
//   if (value.length > 10) {
//     return value.replace(/(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
//   }
//   // Aplica máscara para 10 dígitos (fixo)
//   if (value.length > 6) {
//     return value.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
//   }
//   if (value.length > 2) {
//     return value.replace(/(\d{2})(\d{0,5})/, '($1) $2');
//   }
//   return value;
// }

function App() {
  const [modalItem, setModalItem] = useState(null)

  // const [formData, setFormData] = useState({
  //   name: '',
  //   phone: '',
  //   email: '',
  //   eventType: '',
  //   customEventType: '',
  //   date: '',
  //   exitDate: '',
  //   exitTime: '',
  //   guests: '',
  //   message: '',
  // })

  // const [loading, setLoading] = useState(false)
  // const [error, setError] = useState(false)
  // const [success, setSuccess] = useState(false)
  // const [fieldErrors, setFieldErrors] = useState({})

  // function formValidate() {
  //   const errors = {}
  //   if (!formData.name) errors.name = 'Nome obrigatório.'
  //   if (!formData.phone) errors.phone = 'Telefone obrigatório.'
  //   else if (!validatePhone(formData.phone)) errors.phone = 'Telefone inválido.'
  //   if (!formData.email) errors.email = 'E-mail obrigatório.'
  //   else if (!validateEmail(formData.email)) errors.email = 'E-mail inválido.'
  //   if (!formData.eventType && !formData.customEventType) errors.eventType = 'Tipo de evento obrigatório.'
  //   if (formData.eventType === 'Outro' && !formData.customEventType) errors.customEventType = 'Descreva o tipo de evento.'
  //   setFieldErrors(errors)
  //   return Object.keys(errors).length === 0
  // }

  // Função para criar o corpo do e-mail
  // function createBody(message) {
  //   return {
  //     'senderName': 'Site Recanto Selvatti',
  //     'sender': 'contato@nois.dev.br',
  //     'recipientName': 'Recanto Selvatti',
  //     'recipient': 'recantoselvatti@gmail.com',
  //     'title': 'Nova mensagem via site',
  //     'message': message,
  //     'lead': {
  //       'formId': 18,
  //       'firstName': formData.name,
  //       'lastName': formData.name,
  //       'email': formData.email,
  //       'phone': formData.phone
  //     }
  //   }
  // }

  // Função para enviar o e-mail
  // const sendMail = async (message) => {
  //   const body = createBody(message)
  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_API_CONTROLLER}/send-mail`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'X-Website-Id': process.env.REACT_APP_WEBSITE_ID,
  //         'Authorization': `Bearer ${process.env.REACT_APP_API_MAIL_KEY}`
  //       },
  //       body: JSON.stringify(body)
  //     })
  //     if (response.ok) {
  //       return true
  //     } else {
  //       setError(true)
  //       return false
  //     }
  //   } catch (e) {
  //     console.error('Erro ao enviar e-mail:', e)
  //     setError(true)
  //     return false
  //   }
  // }

  // Função para montar a mensagem
  // function buildMessage() {
  //   const selectedEventType = formData.eventType === 'Outro'
  //     ? formData.customEventType || 'Outro'
  //     : formData.eventType || '-'
  //   const lines = [
  //     'Novo contato via site Recanto Selvatti:',
  //     `Nome: ${formData.name || '-'}`,
  //     `Telefone: ${formData.phone || '-'}`,
  //     `E-mail: ${formData.email || '-'}`,
  //     `Tipo de evento: ${selectedEventType}`,
  //     `Data de entrada: ${formatDateBR(formData.date)}`,
  //     `Data de saída: ${formatDateBR(formData.exitDate)}`,
  //     `Horário de saída: ${formData.exitTime || '-'}`,
  //     `Quantidade de convidados: ${formData.guests || '-'}`,
  //     `Mensagem: ${formData.message || '-'}`,
  //   ]
  //   return lines.join('\n')
  // }

  // Função de submit do formulário
  // const handleSubmit = async (e) => {
  //   e.preventDefault()
  //   if (loading) return
  //   setLoading(true)
  //   setError(false)
  //   setSuccess(false)
  //   if (!formValidate()) {
  //     setLoading(false)
  //     setError(true)
  //     return
  //   }
  //   const message = buildMessage()
  //   if (!await sendMail(message)) {
  //     setLoading(false)
  //     setError(true)
  //     return
  //   }
  //   setFormData({
  //     name: '',
  //     phone: '',
  //     email: '',
  //     eventType: '',
  //     customEventType: '',
  //     date: '',
  //     exitDate: '',
  //     exitTime: '',
  //     guests: '',
  //     message: '',
  //   })
  //   setLoading(false)
  //   setSuccess(true)
  // }

  // const handleChange = ({ target }) => {
  //   const { name, value } = target

  //   let newValue = value;
  //   if (name === 'phone') {
  //     newValue = maskPhone(value);
  //   }

  //   setFormData((currentData) => ({
  //     ...currentData,
  //     ...(name === 'eventType' && value !== 'Outro' ? { customEventType: '' } : {}),
  //     [name]: newValue,
  //   }))
  // }

  return (
    <>
      <Helmet>
        <html lang="pt-BR" />
        <title>Recanto Selvatti | Lazer e Eventos</title>
        <meta
          name="description"
          content="Recanto Selvatti: uma area de lazer rodeada por natureza, com espaco para eventos, momentos em familia e dias especiais."
        />
      </Helmet>

      <main className="page-shell">
        <section className="hero-section">
          <div className="leaf leaf-top-left" aria-hidden="true" />
          <div className="leaf leaf-top-right" aria-hidden="true" />
          <div className="leaf leaf-bottom-left" aria-hidden="true" />
          <div className="leaf leaf-bottom-right" aria-hidden="true" />

          <div className="hero-copy">
            <span className="eyebrow">Área de lazer para viver bons encontros</span>
            <div className="brand-lockup">
              <img src="images/recanto_selvatti_transparente.png" alt="Logotipo do Recanto Selvatti" className="brand-logo" />
            </div>
            <p className="hero-text">
              Um refúgio elegante em meio ao verde para aniversários, confraternizações,
              finais de semana e momentos em família.
            </p>

            <div className="hero-actions">
              <a href="#contato" className="primary-button">Solicitar informações</a>
            </div>

            <ul className="highlights-list">
              {highlights.map((highlight) => (
                <li key={highlight}>{highlight}</li>
              ))}
            </ul>
          </div>

          <div className="hero-visual" aria-label="Área de destaque para fotos do Recanto Selvatti">
            {/* <img src="images/recanto_selvatti_01.jpg" alt="Foto principal do Recanto Selvatti" /> */}
            <video className="brand-video" autoPlay loop muted playsInline>
              <source src="https://d19tjqnmol5wd7.cloudfront.net/files/recantoselvatticombr/recanto_selvatti.mp4" type="video/mp4" />
              Seu navegador não suporta o elemento de vídeo.
            </video>
          </div>
        </section>

        <section className="story-section">
          <div className="section-heading">
            <span className="section-kicker">Experiência</span>
            <h2>Um espaço pensado para você</h2>
          </div>

          <div className="story-grid">
            <p>
              O Recanto Selvatti é um refúgio de sofisticação e natureza em Bauru. Um espaço de alto padrão para até 100 pessoas, pensado para casamentos, eventos corporativos e momentos únicos. Com arquitetura contemporânea, conforto e beleza em cada detalhe, é o cenário ideal para quem busca viver experiências inesquecíveis em um verdadeiro paraíso urbano.
              Construído em um terreno de 550m2, oferece a primeira piscina-praia com revestimento monolítico da região, em um espaço externo pensado nos detalhes, com um jardim iluminado que une natureza e arquitetura.
              Possui uma ampla área gourmet climatizada e equipada, com cozinha de apoio para preparo e finalização de alimentos, além de opção de hospedagem com duas suítes, acomodando até 6 pessoas.
            </p>

            <div className="amenities-card">
              <h3>Destaques</h3>
              <ul>
                {amenities.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section className="gallery-section" id="galeria">
          <div className="section-heading">
            <span className="section-kicker">Galeria</span>
            <h2>Conheça em imagens os espaços do Recanto Selvatti</h2>
            <p>
              Explore detalhes do ambiente, da área externa e dos espaços preparados para receber
              momentos especiais com conforto, natureza e uma atmosfera acolhedora.
            </p>
          </div>

          <div className="gallery-grid">
            {galleryRows.map((row, rowIndex) => (
              <div key={rowIndex} className={`gallery-row cols-${row.cols}`}>
                {row.items.map((item) => (
                  <article key={item.title} className={`gallery-tile ${item.size ?? ''}`} onClick={() => setModalItem(item)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setModalItem(item)}>
                    <img className="gallery-image" src={item.image} alt={item.title} />
                    <div className="gallery-content">
                      {/* <span className="photo-tag">Galeria</span> */}
                      {/* <h3>{item.title}</h3> */}
                      <p>{item.description}</p>
                    </div>
                  </article>
                ))}
              </div>
            ))}
          </div>
        </section>

        <section className="location-section" id="localizacao">
          <div className="location-copy">
            <span className="section-kicker">Localização</span>
            <h2>Veja onde está o Recanto Selvatti</h2>
            <p>
              Confira a localização no mapa e planeje sua chegada com mais facilidade. O acesso é
              simples e o trajeto pode ser aberto diretamente no Google Maps.
            </p>

            <div className="contact-note location-note">
              <strong>Como chegar</strong>
              <p>
                Toque no botão abaixo para abrir a rota no aplicativo do Google Maps e navegar até o
                Recanto Selvatti.
              </p>
            </div>

            <a
              className="primary-button"
              href={googleMapsDirectionsUrl}
              target="_blank"
              rel="noreferrer"
            >
              Abrir no Google Maps
            </a>
          </div>

          <div className="map-frame-wrapper">
            <iframe
              title="Mapa de localização do Recanto Selvatti"
              src={googleMapsEmbedUrl}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </section>

        <section className="contact-section" id="contato">
          <div className="contact-copy">
            <span className="section-kicker">Contato</span>
            <h2>Solicite disponibilidade e receba mais informações</h2>
            <p>
              Entre em contato para consultar datas, esclarecer dúvidas e receber todas as
              informações sobre o Recanto Selvatti. Será um prazer ajudar a planejar o seu momento
              especial em um espaço acolhedor, cercado por natureza e pensado para bons encontros.
            </p>
          </div>

          <div className="contact-form-shell">
            <div className="contact-sidebar">
              <header className="contact-form-header">
                <div className="contact-quick-action contact-quick-action-secondary">
                  <span className="contact-quick-eyebrow">Acompanhe o espaço</span>
                  <strong>Veja as novidades no Instagram</strong>
                  <p>
                    Conheça mais imagens do Recanto Selvatti, acompanhe o ambiente e explore
                    possibilidades para o seu evento.
                  </p>
                  <a
                    className="secondary-button instagram-button contact-quick-link"
                    href={instagramUrl}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Abrir Instagram do Recanto Selvatti"
                  >
                    <FaInstagram aria-hidden="true" />
                    Visitar Instagram
                  </a>
                </div>
              </header>
            </div>

            <div>
            <div className="contact-quick-action contact-quick-action-primary">
              <span className="contact-quick-eyebrow">Agende uma visita</span>
              <strong>Fale com a equipe pelo WhatsApp</strong>
              {/* <p>
                Se preferir um atendimento imediato, envie uma mensagem e consulte datas,
                valores e detalhes do espaço.
              </p> */}
              <a
                className="primary-button contact-quick-link"
                href="https://wa.me/5514997009321"
                target="_blank"
                rel="noreferrer"
                aria-label="Abrir conversa no WhatsApp do Recanto Selvatti"
              >
                Chamar no WhatsApp
              </a>
              {/* <span className="contact-quick-phone">(14) 99700-9321</span> */}
            </div>
            {/* <div className="contact-quick-action contact-quick-action-secondary mt-4">
              <span className="contact-quick-eyebrow">Orçamento</span>
              <strong>Solicite aqui o seu orçamento</strong>
              <a
                className="secondary-button contact-quick-link"
                href="https://docs.google.com/forms/d/e/1FAIpQLSe6Mm_LFpJgowv3-TQ2g3oqYAdaVzyTjrQyQfbWhZ7IMtG7yA/viewform"
                target="_blank"
                rel="noreferrer"
                aria-label="Abrir formulário de orçamento do Recanto Selvatti"
              >
                Preencher formulário
              </a>
            </div> */}
            </div>

            {/* <form className="contact-form" onSubmit={handleSubmit}>
              <label>
                <span>Nome</span>
                <input name="name" type="text" placeholder="Seu nome" value={formData.name} onChange={handleChange} />
                {fieldErrors.name && <span className="field-error" style={{ color: 'red', fontSize: 13 }}>{fieldErrors.name}</span>}
              </label>

              <label>
                <span>Telefone</span>
                <input name="phone" type="tel" placeholder="(00) 00000-0000" value={formData.phone} onChange={handleChange} />
                {fieldErrors.phone && <span className="field-error" style={{ color: 'red', fontSize: 13 }}>{fieldErrors.phone}</span>}
              </label>

              <label>
                <span>E-mail</span>
                <input name="email" type="email" placeholder="voce@exemplo.com" value={formData.email} onChange={handleChange} />
                {fieldErrors.email && <span className="field-error" style={{ color: 'red', fontSize: 13 }}>{fieldErrors.email}</span>}
              </label>

              <label>
                <span>Tipo de evento</span>
                <select name="eventType" value={formData.eventType} onChange={handleChange}>
                  <option value="">Selecione</option>
                  {eventTypes.map((eventType) => (
                    <option key={eventType} value={eventType}>{eventType}</option>
                  ))}
                </select>
                {fieldErrors.eventType && <span className="field-error" style={{ color: 'red', fontSize: 13 }}>{fieldErrors.eventType}</span>}
              </label>

              {formData.eventType === 'Outro' && (
                <label>
                  <span>Qual evento?</span>
                  <input
                    name="customEventType"
                    type="text"
                    placeholder="Descreva o tipo de evento"
                    value={formData.customEventType}
                    onChange={handleChange}
                  />
                  {fieldErrors.customEventType && <span className="field-error" style={{ color: 'red', fontSize: 13 }}>{fieldErrors.customEventType}</span>}
                </label>
              )}

              <label>
                <span>Data de entrada</span>
                <input name="date" type="date" value={formData.date} onChange={handleChange} />
              </label>

              <label>
                <span>Data de saída</span>
                <input
                  name="exitDate"
                  type="date"
                  value={formData.exitDate}
                  onChange={handleChange}
                />
              </label>

              <label>
                <span>Horário de saída</span>
                <input
                  name="exitTime"
                  type="time"
                  value={formData.exitTime}
                  onChange={handleChange}
                />
              </label>

              <label>
                <span>Convidados</span>
                <input name="guests" type="number" min="1" placeholder="Quantidade aproximada" value={formData.guests} onChange={handleChange} />
              </label>

              <label className="full-width">
                <span>Mensagem</span>
                <textarea
                  name="message"
                  rows="5"
                  placeholder="Conte como imagina seu evento ou dia de lazer."
                  value={formData.message}
                  onChange={handleChange}
                />
              </label>

              <div className="submit-actions full-width">
                <button
                  type="submit"
                  className="primary-button submit-button"
                  disabled={loading}
                  style={{ fontSize: '18px', backgroundColor: 'var(--ring)', border: 'none', width: '100%', color: '#222' }}
                >
                  {loading ? (
                    <>
                      <span className="spinner" style={{ marginRight: 8 }} /> ENVIANDO...
                    </>
                  ) : (
                    'ENVIAR'
                  )}
                </button>
              </div>
              {error && (
                <div className="form-error full-width" style={{ color: 'red', marginTop: 12 }}>
                  Ocorreu um erro ao enviar. Tente novamente.
                </div>
              )}
              {success && (
                <div className="form-success full-width" style={{ color: 'green', marginTop: 12 }}>
                  Mensagem enviada com sucesso! Em breve entraremos em contato.
                </div>
              )}
            </form> */}
          </div>
        </section>
      </main>

      {modalItem && (
        <div className="gallery-modal-overlay" onClick={() => setModalItem(null)} role="dialog" aria-modal="true" aria-label={modalItem.title}>
          <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="gallery-modal-close" onClick={() => setModalItem(null)} aria-label="Fechar">&times;</button>
            <img src={modalItem.image} alt={modalItem.title} className="gallery-modal-image" />
            <p className="gallery-modal-caption">{modalItem.description}</p>
          </div>
        </div>
      )}
    </>
  )
}

export default App